import {useTranslation} from 'react-i18next';
import {OptionalLabel} from './styled';

type Props = {
  body: string;
  required: string | boolean;
};
const Label = ({body, required}: Props) => {
  const {t} = useTranslation();
  if (!required) {
    return (
      <>
        <OptionalLabel>{`(${t('optional')}) `}</OptionalLabel>
        <span>{body}</span>
      </>
    );
  }
  return <>{body}</>;
};

export {Label};
